
import { RevIllustration } from '@ds/components/Illustration'
import { mapGetters } from 'vuex'

import {
  getAdvertisingOptionsFromComponent,
  paymentAdvertising,
} from '@payment'

export default {
  components: {
    RevIllustration,
  },
  computed: {
    ...mapGetters({
      paymentMethods: 'countryConfig/paymentMethods',
    }),

    advertising() {
      return paymentAdvertising(
        'search',
        this.paymentMethods,
        getAdvertisingOptionsFromComponent(this),
      )
    },
  },
}
